/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * How the employee travels with a vehicle (FAFD-68). Travels as an int — never renumber.
 */
export type FacilityFlowCoreModulesFleetDtosVehicleTripRole = typeof FacilityFlowCoreModulesFleetDtosVehicleTripRole[keyof typeof FacilityFlowCoreModulesFleetDtosVehicleTripRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetDtosVehicleTripRole = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
